<template>
  <div>
    <div class="d-flex align-items-center">
      <div class="section-title">{{ $t("backuprestoredb") }}</div>
      <div class="d-flex align-items-center">
        <div class="j-radio pl-0 ml-3">
          <b-form-radio v-model="section" name="some-radios" value="backup"
            >Backup Database</b-form-radio
          >
        </div>

        <div class="j-radio pl-0 ml-3">
          <b-form-radio v-model="section" name="some-radios" value="restore"
            >Restore Database</b-form-radio
          >
        </div>
      </div>
    </div>
    <div class="white-wrapper mt-4">
      <!-- SECTION BACKUP -->
      <div class="backup-container" v-if="section == 'backup'">
        <div class="col-lg-6 col-xl-4 mx-auto text-center mb-5">
          <div class="icon-container mb-2">
            <div class="d-flex justify-content-center align-items-center">
              <div class="backup-icon">
                <span class="backupRestoreIcon"></span>
                <div>
                  <span class="section-text">Backup</span>
                </div>
              </div>
            </div>
          </div>

          <b-progress
            v-if="backupPercentage"
            class="my-3"
            :value="backupPercentage"
            :max="100"
            show-progress
            animated
          ></b-progress>

          <div class="d-flex align-items-center justify-content-center my-3">
            <div
              class="btn btn-primary"
              @click="(e) => e.preventDefault()"
              v-if="backingUp"
            >
              Processing Backup
            </div>
            <div
              class="btn btn-success"
              @click="onReset"
              v-else-if="backupPercentage == 100 && !backingUp"
            >
              Completed&nbsp; &#10003;
            </div>
            <div class="btn btn-primary" @click="onShowDialog(1)" v-else>
              Backup Database
            </div>
          </div>
        </div>
      </div>

      <!-- SECTION RESTORE -->
      <div class="backup-container" v-if="section == 'restore'">
        <div class="col-lg-6 col-xl-4 mx-auto text-center mb-5">
          <div class="icon-container mb-2">
            <div class="d-flex justify-content-center align-items-center">
              <div class="restore-icon">
                <span class="backupRestoreIcon"></span>
                <div>
                  <span class="section-text">Restore</span>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <div
              class="dropzone-container"
              @dragover="dragover"
              @dragleave="dragleave"
              @drop="drop"
            >
              <input
                type="file"
                name="file"
                id="fileInput"
                class="d-none"
                @change="uploadSqlFile($event)"
                ref="sqlfileInput"
                accept=".sql"
              />

              <label for="fileInput" class="file-label">
                <div v-if="isDragging">Release to drop files here.</div>
                <div v-else-if="file_name">
                  {{ file_name }}&nbsp; File Attached.
                </div>
                <div v-else>
                  + Drop files here or <u>click here</u> to upload.
                </div>
              </label>
            </div>
          </div>

          <b-progress
            v-if="restorePercentage"
            class="my-3"
            :value="restorePercentage"
            :max="100"
            show-progress
            animated
          ></b-progress>

          <div class="d-flex align-items-center justify-content-center my-3">
            <div
              class="btn btn-primary"
              @click="(e) => e.preventDefault()"
              v-if="restoring"
            >
              Processing Restore
            </div>
            <div
              class="btn btn-success"
              @click="onReset"
              v-else-if="restorePercentage == 100 && !restoring"
            >
              Completed&nbsp; &#10003;
            </div>
            <div class="btn btn-primary" @click="onShowDialog(2)" v-else>
              Restore Database
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="confirmationBackupRestore"
      title="Confirmation"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-2">
          Are you sure you want to
          {{ actionType == 2 ? "Restore" : "Backup" }} Database?
        </p>
        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('confirmationBackupRestore')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-primary"
          @click.prevent.stop="onConfirm(actionType)"
        >
          Confirm
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService.js";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import _ from "lodash";
import { BASEURL } from "@/config/index";
import moment from "moment";
import { backendSocket } from "@/main.js";
import { createUniqueReceiptCodeWithDate } from "@/helper/collection";

export default {
  components: {
    ManagerAuthLogin,
  },
  data() {
    return {
      noAuth: false,
      section: "backup",
      backupPercentage: 0,
      restorePercentage: 0,
      file_url: "",
      file_name: "",
      isDragging: false,
      restoring: false,
      backingUp: false,
      actionType: null,
      uniqueIdentitfier: createUniqueReceiptCodeWithDate(),
    };
  },
  mounted() {
    backendSocket.on(`sqlBackupPercent_${this.uniqueIdentitfier}`, (data) => {
      const { percent } = data;
      if (percent) {
        this.restorePercentage = percent || 0;
      }
    });
  },
  methods: {
    onClickBack() {
      this.$router.push({ path: "/" });
    },
    show1: function () {
      this.section.one = true;
      this.section.two = false;
    },
    onShowDialog(type) {
      this.actionType = type;
      this.$bvModal.show("confirmationBackupRestore");
    },
    onConfirm(actionType) {
      if (actionType == 1) {
        this.onStartBackup();
      } else if (actionType == 2) {
        this.onStartRestore();
      }
      this.$bvModal.hide("confirmationBackupRestore");
    },
    onReset() {
        this.restorePercentage = 0;
        this.backupPercentage = 0;
        this.backingUp = false;
        this.restoring = false;
        this.file_url = "";
        this.file_name = "";
        this.actionType = null;
        this.$bvModal.hide("confirmationBackupRestore");
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.uploadSqlFile({ target: { files: e.dataTransfer.files } });
      this.isDragging = false;
    },
    uploadSqlFile: function (file) {
      let self = this;
      let formData = new FormData();
      let originalFile = file.target.files[0].name;
      formData.append("file", file.target.files[0]);
      formData.append("filePath", "SQL Backup File");
      MasterService.GlobalUploadAllTypeFile(formData)
        .then((response) => {
          const { data } = response;
          data.message ? this.$toasted.show(data.message) : "";
          if (data.status) {
            self.file_url = data.path;
            self.file_name = originalFile;
          }
        })
        .catch((error) => {
          alert(
            "Sorry! Something went wrong. kindly contact your administrator"
          );
        });
    },
    onStartBackup() {
      this.backupPercentage = 0;
      var newDate = moment().format("YYYYMMDDHHmm");
      const dumpFileName = String(newDate) + "_dump.sql";
      const options = {
        onDownloadProgress: (event) => {
          const { loaded, total } = event;
          const percent = Math.floor((loaded / total) * 100);
          this.backupPercentage = percent;
        },
      };
      let loader = this.$loading.show();
      this.backingUp = true;
      MasterService.onBackupDatabase(options)
        .then((response) => {
          const blob = new Blob([response.data]);
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = dumpFileName;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          this.backingUp = false;
          loader.hide();
          console.log("this.backupPercentage", this.backupPercentage);
        });
    },
    onStartRestore() {
      if (!this.file_url) {
        this.$toasted.show("Please Select File");
      } else {
        this.restorePercentage = 0;
        let payload = {
          fileUrl: this.file_url,
          id: this.uniqueIdentitfier,
        };
        this.restoring = true;
        console.log("this.uniqueIdentitfier", this.uniqueIdentitfier);
        let loader = this.$loading.show();
        MasterService.onRestoreDatabase(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            this.restoring = false;
            loader.hide();
          });
      }
    },
  },
};
</script>
<style>
.invalid_input {
  border: 1px solid red !important;
  border-radius: 10px;
}
.customer_drop_down {
  background-color: none !important;
}

.disableRefundBtn {
  opacity: 0.5;
  pointer-events: none;
}

.backup-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: calc(100% - 240px) !important;
}

.backup-box {
  height: 60px;
  width: 500px;
  border-radius: 10px;
  border: 2px dashed var(--primary);
  /* line-height: 50px; */
  color: var(--primary);
  font-size: 17px;
  background: transparent;
}

.section-text {
  font-weight: bold;
  color: #3d71ae;
  font-size: 18px;
  text-transform: uppercase;
  padding-right: 20px;
}

.dropzone-container {
  height: 60px;
  width: 500px;
  border-radius: 10px;
  border: 2px dashed var(--primary);
  /* line-height: 50px; */
  color: var(--primary);
  font-size: 17px;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dropzone-container label {
  color: var(--primary) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/BackupRestoreComponent/backupRestore.vue